import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AnimalModel} from '../models/animal.model';
import {AnimalSheltersRepository} from '../../../shared/states/animal-shelter.repository';
import {AnimalShelterModel} from "../../../shared/models/animal-shelter.model";
import {AnimalChangeShelterService} from "../services/animal-change-shelter.service";
import {WaitingDialogService} from "../../../shared/services/waiting-dialog.service";
import {take, switchMap, takeWhile} from 'rxjs';
import {AnimalRepository} from "../states/animal.repository";
import {AnimalOriginRepository} from "../states/animal-origin.repository";
import {AnimalWhereaboutsRepository} from "../states/animal-whereabouts.repository";
import {AnimalEditService} from "../services/animal-edit.service";

@Component({
  selector: 'app-animal-move-history-dialog',
  templateUrl: './animal-move-history-dialog.component.html',
  styleUrls: ['./animal-move-history-dialog.component.scss'],
  standalone: false,
})
export class AnimalMoveHistoryDialogComponent implements OnInit, OnDestroy {
  @Input() animal!: AnimalModel;

  alive: boolean = true;
  visible: boolean = false;
  histories: any[] = [];
  shelters: AnimalShelterModel[] = [];

  constructor(
    private readonly _animalChangeShelterService: AnimalChangeShelterService,
    private readonly _animalShelterRepo: AnimalSheltersRepository,
    private readonly _waitingDialogService: WaitingDialogService,
    private readonly _animalRepository: AnimalRepository,
    private readonly _animalOriginRepository: AnimalOriginRepository,
    private readonly _animalWhereaboutsRepository: AnimalWhereaboutsRepository,
    private readonly _animalEditService: AnimalEditService,
  ) {
  }

  ngOnInit(): void {
    if (!this.animal) return;

    this._animalEditService.moveHistoryDialogVisible.pipe(takeWhile(() => this.alive)).subscribe((openModal) => {
      this.visible = openModal;
    });

    this._animalShelterRepo.getAnimalShelters().subscribe(shelters => {
      this.shelters = shelters;
    });
    this._animalChangeShelterService.getShelterChangeHistories(this.animal.id).subscribe({
      next: (histories) => {
        this.histories = histories;
      },
      error: () => {
        this.histories = [];
      }
    });
  }

  closeModal() {
    this._animalEditService.toggleMoveHistoryDialog();
  }

  getShelterNameById(id: number): string {
    return this.shelters.find(s => s.id === id)?.title || `Tierheim #${id}`;
  }

  saveChanges() {
    if (!this.animal || !this.histories.length) return;

    this._waitingDialogService.showWaitingDialog(true);
    const lastHistory = this.histories[0];

    // Zuerst Stores leeren
    this._animalChangeShelterService.undoShelterChange(lastHistory.id)
    .pipe(
      switchMap(() => {
        return this._animalChangeShelterService.getShelterChangeHistories(this.animal!.id);
      })
    )
    .subscribe({
      next: (updatedHistories) => {
        this.histories = updatedHistories || [];
        this._waitingDialogService.showWaitingDialog(false);
      },
      complete: () => {
          this._animalOriginRepository.clearByAnimalIdAndStateId(this.animal!.id, lastHistory.oldOriginId);
          this._animalWhereaboutsRepository.clearByAnimalIdAndStateId(this.animal!.id, lastHistory.oldWhereaboutId);
          this._animalRepository.updateAnimalStore(this.animal.id, {animalShelter: lastHistory.oldShelterId});
          this._waitingDialogService.showWaitingDialog(false);
          this.closeModal();
        }
      });
  }

  get sortedHistories() {
    return this.histories.sort((a, b) =>
      new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
